exports.components = {
  "component---src-templates-homepage-tsx": () => import("./../../../src/templates/homepage.tsx" /* webpackChunkName: "component---src-templates-homepage-tsx" */),
  "component---src-templates-venue-tsx": () => import("./../../../src/templates/venue.tsx" /* webpackChunkName: "component---src-templates-venue-tsx" */)
}

